export const getBrowserWidth = () => window?.innerWidth || 0
export const getBrowserHeight = () => window?.innerHeight || 0
